import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { showSuccess } from 'actions/utils';
import { getAllUserData } from 'actions/user';
import InlineSpinner from 'components/atoms/Spinner/InlineSpinner';
import { Header } from 'components/atoms/Header/Header';
import { strings } from 'components/checkout/billing/strings';
import { Language } from 'language/Language';
import { isCountriesTax } from '../../../countriesTax';
import './_CheckoutBilling.scss';

const CheckoutBilling = ({ history }) => {
  // this is because wordpress changes the value
  if (process.env.REACT_APP_PADDLE_ENVIRONMENT === 'sandbox') {
    window.Paddle.Environment.set('sandbox');
  }
  const { userInfo } = useSelector((state) => state);
  const {
    priceProduct, countryUser, product,
  } = useSelector((state) => state.siteInfo);
  const { Paddle } = window;
  const dispatch = useDispatch();
  const language = Language();

  const handleSuccess = async () => {
    setTimeout(async () => {
      showSuccess({
        title: 'PURCHASE SUCCESSFUL.',
        text: 'You can find your license in the Orders section',
        className: 'modal-item',
      })
        .then(async () => {
          await dispatch(getAllUserData());
          history.push(`${language === 'japan' ? '/ja/私のアカウント' : '/my-account'}/orders`);
        });
    }, 2000);
  };

  const openCheckout = () => {
    Paddle.Checkout.open({
      product,
      email: userInfo.email,
      country: countryUser,
      successCallback: handleSuccess,
      allowQuantity: true,
    });
  };

  return (
    <div className='checkout-content'>
      <div className='checkout-order'>
        <h3 style={{ marginBottom: '50px' }}>{strings[language].title}</h3>
        <div className='checkout-order__group'>
          <div>
            <h3>{strings[language].product}</h3>
          </div>
          <div>
            <h3 style={{ textAlign: 'right' }}>{strings[language].subtotal}</h3>
          </div>
        </div>
        <div className='checkout-payment__data'>
          <div className='checkout-order__group'>
            <span style={{ width: '60%' }}>
              360 WalkMix Creator™
              {' '}
              <strong>
                x1
              </strong>
            </span>
            {priceProduct
              ? <h3 className='checkout-payment__price'>{priceProduct.net}</h3>
              : <InlineSpinner />}
          </div>
          <div className='checkout-order__group' style={{ marginTop: '20px' }}>
            <span>{strings[language].subtotal}</span>
            {priceProduct
              ? <h3 className='checkout-payment__price'>{priceProduct.net}</h3>
              : <InlineSpinner />}
          </div>
          {priceProduct && priceProduct.tax_included
            && (
              <div className='checkout-order__group' style={{ marginTop: '20px' }}>
                <span>{strings[language].taxes}</span>
                {priceProduct
                  ? <h3 className='checkout-payment__price'>{priceProduct.tax}</h3>
                  : <InlineSpinner />}
              </div>
            )}
        </div>
        <div className='checkout-order__group'>
          <Header text={strings[language].total} />
          {priceProduct
            ? (<h2 className='checkout-payment__price'>{priceProduct.gross}</h2>)
            : <InlineSpinner />}
        </div>
      </div>
      {isCountriesTax(countryUser)
          && (
            <div className='' style={{ marginTop: '20px' }}>
              <p>{`Pricing is listed in ${countryUser} and does not include applicable taxes.`}</p>
              <p>Pricing at checkout will be local currency with applicable taxes applied.</p>
            </div>
          )}
      <button
        type='submit'
        className='main-btn'
        style={{ marginBottom: '50px' }}
        onClick={openCheckout}
      >
        {strings[language].button}
      </button>
      <p style={{ fontSize: '1.2em', textAlign: 'center' }}>
        <strong>{strings[language].coupon}</strong>
        {strings[language].couponInfo}
      </p>
    </div>
  );
};

CheckoutBilling.propTypes = {
  history: PropTypes.object,
};

export default CheckoutBilling;
